"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomPickersDay = void 0;
const index_1 = require("../index");
const PickersDay_1 = require("@mui/x-date-pickers/PickersDay");
const moment_1 = __importDefault(require("moment"));
exports.CustomPickersDay = (0, index_1.styled)(PickersDay_1.PickersDay, {
    shouldForwardProp: () => true,
})(({ theme, variant, date, value }) => {
    if (variant !== 'week') {
        return {};
    }
    // TODO: Deprecate moment methods for MDT
    // https://medely.atlassian.net/browse/FAC-939
    const startOfWeek = value.clone().startOf('week');
    const endOfWeek = value.clone().endOf('week');
    const isDayBetween = date.isBetween(startOfWeek, endOfWeek, null, '[]');
    const isFirstDay = date.isSame(startOfWeek, 'day');
    const isLastDay = date.isSame(endOfWeek, 'day');
    const isSelectedDate = date.isSame(value, 'day');
    const isToday = date.isSame((0, moment_1.default)(), 'day');
    return {
        // !important required to override some MUI set styles
        ...(isDayBetween && {
            borderRadius: 0,
            backgroundColor: theme?.palette?.primary?.main,
            color: theme?.palette?.common?.white,
            '&:hover, &:focus': {
                backgroundColor: theme?.palette?.primary?.dark,
            },
        }),
        ...(isToday &&
            !isDayBetween && {
            color: `${theme?.palette?.primary?.main} !important`,
            backgroundColor: 'white !important',
            borderColor: `${theme?.palette?.primary?.main} !important`,
            borderRadius: '50% !important',
            '&:hover': {
                backgroundColor: `${theme?.palette?.primary?.light} !important`,
            },
        }),
        ...(isToday &&
            isDayBetween && {
            color: `${theme?.palette?.primary?.dark} !important`,
            backgroundColor: `${theme?.palette?.primary?.main} !important`,
            border: 'none !important',
            '&:hover': {
                color: 'white !important',
                backgroundColor: `${theme?.palette?.primary?.dark} !important`,
            },
        }),
        ...(isSelectedDate && {
            backgroundColor: `${theme?.palette?.primary?.main} !important`,
            '&:hover': {
                color: 'white !important',
                backgroundColor: `${theme?.palette?.primary?.dark} !important`,
            },
        }),
        ...(isFirstDay && {
            borderTopLeftRadius: '50%',
            borderBottomLeftRadius: '50%',
        }),
        ...(isLastDay && {
            borderTopRightRadius: '50%',
            borderBottomRightRadius: '50%',
        }),
    };
});
